import gql from "graphql-tag";

const MUTATION_MSC_BLACKLISTED_RESOURCES = gql`
  mutation MscBlacklistResource(
    $input: ManagedServicesConnectorBlacklistedResourceUpdateInput!
  ) {
    managedServicesConnectorBlacklistedResourceUpdate(input: $input) {
      metadata {
        conversationId
        message
        statusCode
        statusText
      }
      result
    }
  }
`;

export { MUTATION_MSC_BLACKLISTED_RESOURCES };
